export const compareByProperty = (field) => {
  return (a, b) => {
    const x = a[field];
    const y = b[field];
    if (x === "" || x === null || x === undefined) return 1;
    if (y === "" || y === null || y === undefined) return -1;
    if (x === y) return 0;
    return x < y ? -1 : 1;
  };
};

export const compareByArrayProperty = (field) => {
  return (a = [], b = []) => {
    const c = a[field] || "";
    const d = b[field] || "";
    const x = c[0]?.toLowerCase()?.replace(/,/g, "") || "";
    const y = d[0]?.toLowerCase()?.replace(/,/g, "") || "";
    if (x === "" || x === null) return 1;
    if (y === "" || y === null) return -1;
    if (x === y) return 0;
    return x < y ? -1 : 1;
  };
};
